import { IAddRequrstPageConfig } from '../../interface/config/add-requrst-page-config.interface';
import { IHomePageConfig } from '../../interface/config/home-page-config.interface';
import { IProjectConfig } from '../../interface/config/project-config.interface';

export const initHomePageConfigData: IHomePageConfig = {

    sendingCitizenOtpCodeVia: 'EMAIL',
    hasAddFileToRequestOption: false,
    hasCancelPermitOption: false,
    hasCheckRequestStatusOption: false,
    hasCheckValidityPeriodOption: false,
    hasNewRequestOption: true,
    hasUpdateVehicleDetailsOption: false,
    hasRenewedPermitOption: false,
}

export const initAddRequrstPageConfigData: IAddRequrstPageConfig = {
    hasAdditionalAddress: false,
    hasAdditionalPersonIdFile: false,
    colorAndType: false,
    permitTypes: {
        regular: false,
        golden: false,
        student: false,
        handicapped: false,
        municipalEmployee: false,
        noneResident: false,
        permitByZone: false,
        business: false,
    },
    gilHaZahavAge: 67,
    extraFiles: {
        hasExtraFile: false,
        hasRentingApartmentFiles: false,
        hasBusinessFiles: false,
    },
    initFormData: {}
}

export const initProjectConfigData: IProjectConfig = {
    hadProjectConfigLoaded: false,
    projectId: -1,
    vehicleGroups: [],
    colors: [],
    makers: [],
    streets: [],
    hebName: '',
    engName: '',
    cityLogUrl: '',
    addRequestPageConfig: initAddRequrstPageConfigData,
    homePageConfig: initHomePageConfigData,
}